import Title from 'antd/lib/typography/Title';
import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import PortfolioCard from './PortfolioCard';
import { useEffect } from 'react';
import { fetchPortfolio } from "../../../redux/actions/portfolioActions";
import PortfolioNews from './PortfolioNews';
import Optimization from './Optimization';
import PortfolioDetails from './PortfolioDetails';
import LinearProgressBar from '../../utils/LinearProgressBar';

const StockPortfolio = () => {

    const user = useSelector(state => state.user?.user);
    const user_portfolio = useSelector(state => state.portfolio?.portfolio_list);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    
    const fetchUserPortfolio = async () => {
        const data = {
            userID: user?._id,
        }
        setLoading(true);
        await dispatch(fetchPortfolio(data));
        setLoading(false);
    }

    useEffect(() => {
        fetchUserPortfolio();
        // eslint-disable-next-line
    }, [])

    const portfolioCards = user_portfolio?.length > 0 
                            ?  user_portfolio?.map((item, i) => (
                                <PortfolioCard key={i} stock={item}/>
                            ))
                            : <div className="w-100">
                                <h4 className="text-center">Your stock portfolio is empty</h4>
                              </div> 
    return (
        
        <div className='container pt-3 px-5 my-4'>
            <Title level={3} className="text-center my-2">Stock Portfolio</Title>
            <div className='row my-5'>
                {
                    loading
                    ? (
                        <div className='w-75 mx-auto text-center'>
                            <LinearProgressBar />
                        </div>
                    ) 
                    : (
                       portfolioCards
                      )
                }
            </div>
            <hr/>
            <div className="w-100 mt-5 ">
                            <ul className="nav nav-pills mb-3 justify-content-center" id="pills-tab" role="tablist">
                                <li className="nav-item mx-2" role="presentation">
                                    <button className="nav-link btn-sm finance-link active" id="pills-details-tab" data-bs-toggle="pill" data-bs-target="#pills-details" type="button" role="tab" aria-controls="pills-details" aria-selected="true">
                                        Portfolio Details
                                    </button>
                                </li>
                                <li className="nav-item mx-2" role="presentation">
                                    <button className="nav-link btn-sm finance-link" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">
                                        Portfolio News
                                    </button>
                                </li>
                                <li className="nav-item mx-2" role="presentation">
                                    <button className="nav-link btn-sm finance-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">
                                        Optimizations
                                    </button>
                                </li>
                            </ul>
                            <div className="tab-content" id="pills-tabContent">
                                <div className="tab-pane fade show active" id="pills-details" role="tabpanel" aria-labelledby="pills-details-tab">
                                    <PortfolioDetails/>
                                </div>
                                <div className="tab-pane fade" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                                    <PortfolioNews stocks={user_portfolio}/>
                                </div>
                                <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                                    <Optimization stocks={user_portfolio}/>
                                </div>
                            </div>
            </div>
        </div>
    )
}

export default StockPortfolio
